var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-wrapper" }, [
    ![10, 12, 14, 15].includes(_vm.roleId)
      ? _c("ul", { staticClass: "menu_ul" }, [
          _vm.roleId !== 13
            ? _c(
                "li",
                {
                  class: { active_page: _vm.active_tab == "profile" },
                  on: {
                    click: function ($event) {
                      return _vm.settings("profile")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "menu_icon",
                    attrs: {
                      src: "/static/images/icons/profile_icon.svg",
                      alt: "profile-icon",
                    },
                  }),
                  _c("span", [_vm._v("Profile")]),
                ]
              )
            : _vm._e(),
          _vm.roleId !== 4
            ? _c(
                "li",
                {
                  class: {
                    active_page: [
                      "notifications",
                      "dashboard",
                      "preferences",
                      "team",
                      "billing",
                      "services",
                    ].includes[_vm.active_tab],
                  },
                },
                [
                  _c("img", {
                    staticClass: "menu_icon",
                    attrs: {
                      src: "/static/images/icons/settings_icon.svg",
                      alt: "settings-icon",
                    },
                  }),
                  _c("span", [_vm._v("Account Settings")]),
                ]
              )
            : _vm._e(),
          _vm.roleId !== 4 && _vm.roleId !== 13
            ? _c("li", { staticClass: "sub_menu_wrapper" }, [
                _c("ul", { staticClass: "sub_menu" }, [
                  _c(
                    "li",
                    {
                      class: { active_page: _vm.active_tab == "notifications" },
                      on: {
                        click: function ($event) {
                          return _vm.settings("notifications")
                        },
                      },
                    },
                    [_c("span", [_vm._v("Notifications")])]
                  ),
                  _vm.isDashboardCustomizable && ![4, 11].includes(_vm.roleId)
                    ? _c(
                        "li",
                        {
                          class: { active_page: _vm.active_tab == "dashboard" },
                          on: {
                            click: function ($event) {
                              return _vm.settings("dashboard")
                            },
                          },
                        },
                        [_c("span", [_vm._v("Dashboard")])]
                      )
                    : _vm._e(),
                  _c(
                    "li",
                    {
                      class: { active_page: _vm.active_tab == "preferences" },
                      on: {
                        click: function ($event) {
                          return _vm.settings("preferences")
                        },
                      },
                    },
                    [_c("span", [_vm._v("Preferences")])]
                  ),
                  [1, 5, 9].includes(_vm.roleId)
                    ? _c(
                        "li",
                        {
                          class: { active_page: _vm.active_tab == "team" },
                          on: {
                            click: function ($event) {
                              return _vm.settings("team")
                            },
                          },
                        },
                        [_c("span", [_vm._v("Team")])]
                      )
                    : _vm._e(),
                  [1, 5, 9].includes(_vm.roleId)
                    ? _c(
                        "li",
                        {
                          class: { active_page: _vm.active_tab == "services" },
                          on: {
                            click: function ($event) {
                              return _vm.settings("services")
                            },
                          },
                        },
                        [_c("span", [_vm._v("Services")])]
                      )
                    : _vm._e(),
                  !_vm.isREP && [1, 5].includes(_vm.roleId)
                    ? _c(
                        "li",
                        {
                          class: { active_page: _vm.active_tab == "billing" },
                          on: {
                            click: function ($event) {
                              return _vm.settings("billing")
                            },
                          },
                        },
                        [_c("span", [_vm._v("Billing")])]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm.roleId == 13 && _vm.accountTypeId === 2
            ? _c("li", { staticClass: "sub_menu_wrapper" }, [
                _c("ul", { staticClass: "sub_menu" }, [
                  _c(
                    "li",
                    {
                      class: { active_page: _vm.active_tab == "team" },
                      on: {
                        click: function ($event) {
                          return _vm.settings("team")
                        },
                      },
                    },
                    [_c("span", [_vm._v("Team")])]
                  ),
                ]),
              ])
            : _vm._e(),
          ![4, 7, 13].includes(_vm.roleId)
            ? _c(
                "li",
                {
                  class: { active_page: _vm.active_tab == "tour" },
                  on: {
                    click: function ($event) {
                      return _vm.settings("tour")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "menu_icon",
                    attrs: {
                      src: "/static/images/icons/virtual_tour_icon.svg",
                      alt: "virtual-icon",
                    },
                  }),
                  _c("span", [_vm._v("Virtual Tour")]),
                ]
              )
            : _vm._e(),
          _c(
            "li",
            {
              class: { active_page: _vm.active_tab == "logout" },
              on: {
                click: function ($event) {
                  return _vm.settings("logout")
                },
              },
            },
            [
              _c("img", {
                staticClass: "menu_icon",
                attrs: {
                  src: "/static/images/icons/logout_icon.svg",
                  alt: "logout-icon",
                },
              }),
              _c("span", [_vm._v("Log out")]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }